const NotificationCircle = ({count}:{count:number}) => {
    return (
        <span className="notification-count">
            {count > 99 ? "99+" : count}
        </span>
    )
}

export default NotificationCircle;